import React, { useState } from "react";
import { IAccount, ITotalByMonth } from "../../../common/accounts2";
import { BalanceBlock } from "./BalanceBlock";
import { TotalByMonthBlock } from "./TotalByMonthBlock";

interface IAccountTotalBlock {
  account: IAccount;
  setLookButtonIsClicked: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AccountTotalBlock = ({ account, setLookButtonIsClicked }: IAccountTotalBlock) => {
  const [total, setTotal]=useState<ITotalByMonth>();
  return (
    <div className="payment">
      <BalanceBlock total={total!} account={account} />
      <TotalByMonthBlock account={account} setTotal={setTotal} setLookButtonIsClicked={setLookButtonIsClicked} />
    </div>
  );
};
